(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', () => {
      const {
        hydrateComponents
      } = window.PoleneLibs.Hydration;
      (async () => {
        const components = [Promise.resolve().then(function () { return theme$1; }), Promise.resolve().then(function () { return componentCustomerNav$1; }), Promise.resolve().then(function () { return componentAllArticles$1; }), Promise.resolve().then(function () { return blogViewerArticle$1; }), Promise.resolve().then(function () { return orderTracker$1; }), Promise.resolve().then(function () { return fragmentStoreSelector$1; }), Promise.resolve().then(function () { return fragmentSplitscreenMap$1; }), Promise.resolve().then(function () { return sectionArticleList$1; })];
        const componentsObj = hydrateComponents(components);
        await componentsObj.hydrate?.();
      })();
    });

    const {
      getElementByRef: getElementByRef$5
    } = window.PoleneLibs.Refs;
    const classes$1 = {
      beige: 'theme-beige'
    };
    const colors = {
      beige: '#EDEAE7',
      white: '#fff'
    };
    var theme = () => {
      const ref = getElementByRef$5(['theme']);
      if (!ref.theme) {
        document.body.classList.remove(classes$1.beige);
        const metaElement = document.querySelector("meta[name='theme-color']");
        if (metaElement) metaElement.content = `${colors.white}`;
        return;
      }
      const {
        theme
      } = ref.theme.dataset;
      if (theme === 'beige') {
        document.body.classList.add(classes$1.beige);
        const metaElement = document.querySelector("meta[name='theme-color']");
        if (metaElement) metaElement.content = `${colors.beige}`;
      }
    };

    var theme$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: theme
    });

    const {
      isMobile: isMobile$1
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef: getElementByRef$4
    } = window.PoleneLibs.Refs;
    class ComponentCustomerNav extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.init();
      }
      disconnectedCallback() {}
      init() {
        const {
          customerNavigationList,
          customerNavigationActiveLink
        } = getElementByRef$4(['customer-navigation-list', 'customer-navigation-active-link'], this);
        if (customerNavigationList) {
          this.navList = customerNavigationList;
          this.activeItem = customerNavigationActiveLink;
          this.setNavPosition();
        }
      }
      setNavPosition() {
        if (this.navList) {
          if (isMobile$1() && this.activeItem) {
            const navWidth = this.navList.offsetWidth;
            const activeItemPosition = this.activeItem.parentElement.offsetLeft;
            const activeItemWidth = this.activeItem.parentElement.offsetWidth;
            const scrollPosition = activeItemPosition - navWidth / 2 + activeItemWidth / 2;
            this.navList.scrollTo({
              left: scrollPosition,
              behavior: 'instant'
            });
          }
          this.navList.classList.add('is-revealed');
        }
      }
      static define() {
        if (!customElements.get('component-customer-nav')) {
          customElements.define('component-customer-nav', ComponentCustomerNav);
        }
      }
    }
    var componentCustomerNav = () => {
      ComponentCustomerNav.define();
    };

    var componentCustomerNav$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentCustomerNav
    });

    const cleanPath = path => path.replace(/\/+/g, '/');
    const cleanPaths = paths => {
      return Object.fromEntries(Object.entries(paths).map(([key, path]) => [key, cleanPath(path)]));
    };
    const ROOT_PATH = window?.Shopify?.routes?.root || '/';
    const PROXY_BASE_PATH = cleanPath(`${ROOT_PATH}/apps/polene-theme-features`);
    cleanPaths({
      WISHLIST: `${ROOT_PATH}/pages/wishlist`,
      ACCOUNT: `${ROOT_PATH}/account`,
      LOGIN: `${ROOT_PATH}/account/login`,
      LOGIN_MULTI_PASS: `${ROOT_PATH}/account/login/multipass`
    });
    const API_PROXY = {
      RETURNS: PROXY_BASE_PATH + '/order-returns',
      RETURN_BUTTON: PROXY_BASE_PATH + '/order-return-button',
      ORDER_HISTORY: PROXY_BASE_PATH + '/order-history',
      ORDER_INVOICE: PROXY_BASE_PATH + '/order-invoice',
      ORDER_CREDIT_NOTE: PROXY_BASE_PATH + '/order-credit-note',
      ORDER_DETAILS: PROXY_BASE_PATH + '/order-details',
      ORDER_DETAILS_SAP: PROXY_BASE_PATH + '/order-details-sap',
      DELETE_ACCOUNT: PROXY_BASE_PATH + '/delete-account',
      CREATE_CUSTOMER: PROXY_BASE_PATH + '/customer-create',
      UPDATE_CUSTOMER: PROXY_BASE_PATH + '/customer-update',
      CUSTOMER_SMS_CONSENT: PROXY_BASE_PATH + '/customer-sms-marketing',
      CUSTOMER_WISHLIST: PROXY_BASE_PATH + '/customer-wishlist',
      STOREFRONT: PROXY_BASE_PATH + '/storefront',
      MARKETING_SUBSCRIBE: PROXY_BASE_PATH + '/marketing-subscribe',
      BACK_IN_STOCK_SUBSCRIBE: PROXY_BASE_PATH + '/back-in-stock-subscribe',
      WISHLIST: PROXY_BASE_PATH + '/wishlist',
      ORDER_TRACKER: PROXY_BASE_PATH + '/order-tracker',
      BIS_SUBSCRIPTIONS: PROXY_BASE_PATH + '/back-in-stock-subscriptions',
      ALL_ARTICLES: PROXY_BASE_PATH + '/blog-articles',
      CART_IDENTITY: PROXY_BASE_PATH + '/cart-identity',
      CUSTOMER_IDENTITY: PROXY_BASE_PATH + '/customer-identity',
      KLAVIYO_RESOLVER: PROXY_BASE_PATH + '/klaviyo-resolver'
    };
    window.P1?.klaviyo?.public_key;
    window.P1?.klaviyo?.list_id;
    const FOCUSABLE_SELECTORS = ['button:not([disabled])', '[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', '[tabindex]:not([tabindex="-1"]):not([disabled])'].join(', ');

    const {
      BaseComponent
    } = window.PoleneLibs.BaseComponent;
    const {
      getElementByRef: getElementByRef$3
    } = window.PoleneLibs.Refs;
    const {
      intersection: intersection$1
    } = window.PoleneLibs.Observer;
    const {
      ArticleCardVisibleEvent: ArticleCardVisibleEvent$1
    } = window.PoleneLibs.BlogArticleEvents;
    const ROOT_MARGIN_BOTTOM_PX = 1200;
    const PREFETCH_ROOT_MARGIN_PX = 200;
    const CARD_SELECTOR$1 = '.all-articles__card';
    const PAGINATION_SELECTOR = '[data-ref="all-articles-pagination"]';
    class ComponentAllArticles extends BaseComponent {
      nextCursor = null;
      hasNextPage = false;
      isLoading = false;
      firstPageLoaded = false;
      activeBlog = null;
      includedBlogs = new Set();
      onMount() {
        this.initializeElements();
        this.prefetchObserver = intersection$1(undefined, this.handlePrefetchIntersection, {
          rootMargin: `0px 0px ${PREFETCH_ROOT_MARGIN_PX}px 0px`,
          threshold: [0]
        });
        this.loadNextPage();
      }
      onUnmount() {
        this.observer?.disconnect();
        this.observer = undefined;
        this.prefetchObserver?.disconnect();
        this.prefetchObserver = undefined;
        this.loadController?.abort();
        this.loadController = undefined;
      }
      initializeElements = () => {
        const {
          allArticlesGrid
        } = getElementByRef$3('all-articles-grid', this);
        this.grid = allArticlesGrid;
        const {
          allArticlesSentinel
        } = getElementByRef$3('all-articles-sentinel', this);
        this.sentinel = allArticlesSentinel;
        const {
          allArticlesLive
        } = getElementByRef$3('all-articles-live', this);
        this.liveRegion = allArticlesLive;
        this.includedBlogs = new Set((this.dataset.includedBlogs ?? '').split(',').map(handle => handle.trim()).filter(handle => handle.length > 0));
      };
      observeSentinel = () => {
        this.observer?.disconnect();
        if (!this.sentinel || !this.hasNextPage) return;
        this.observer = intersection$1(this.sentinel, this.handleIntersection, {
          rootMargin: `0px 0px ${ROOT_MARGIN_BOTTOM_PX}px 0px`,
          threshold: [0]
        });
      };
      handleIntersection = entries => {
        for (const entry of entries) {
          if (entry.isIntersecting) this.loadNextPage();
        }
      };
      handlePrefetchIntersection = entries => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const card = entry.target;
          this.prefetchObserver?.unobserve(card);
          const ref = card.dataset.article;
          const link = card.querySelector('.all-articles__card__link');
          if (!ref || !link?.href) continue;
          card.dispatchEvent(new ArticleCardVisibleEvent$1(ref, link.href));
        }
      };
      filterByBlog = handle => {
        this.activeBlog = handle;
        const visible = this.applyFilter();
        if (handle && this.hasNextPage) this.loadNextPage();
        return visible;
      };
      applyFilter = () => {
        if (!this.grid) return 0;
        let visible = 0;
        this.grid.querySelectorAll(CARD_SELECTOR$1).forEach(card => {
          const blog = card.dataset.blog ?? '';
          const match = this.activeBlog ? blog === this.activeBlog : this.includedBlogs.size === 0 || this.includedBlogs.has(blog);
          card.classList.toggle('is-hidden', !match);
          if (match) visible += 1;
        });
        this.assignMobileOrder();
        return visible;
      };
      loadNextPage = async () => {
        if (this.isLoading || !this.grid) return;
        if (this.firstPageLoaded && !this.hasNextPage) return;
        this.isLoading = true;
        this.grid.setAttribute('aria-busy', 'true');
        this.loadController?.abort();
        const localController = new AbortController();
        this.loadController = localController;
        try {
          const html = await this.fetchArticles(this.nextCursor, localController.signal);
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const cards = Array.from(doc.querySelectorAll(CARD_SELECTOR$1)).map(card => document.importNode(card, true));
          const fragment = document.createDocumentFragment();
          cards.forEach(card => fragment.appendChild(card));
          this.grid.appendChild(fragment);
          cards.forEach(card => this.prefetchObserver?.observe(card));
          this.revealImages(this.grid);
          this.applyFilter();
          this.initStreamingVideos();
          this.firstPageLoaded = true;
          this.syncPaginationState(doc);
          this.announce(cards.length);
          if (this.hasNextPage) {
            this.observeSentinel();
          } else {
            this.observer?.disconnect();
          }
        } catch (error) {
          if (error instanceof DOMException && error.name === 'AbortError') return;
        } finally {
          if (this.loadController === localController) {
            this.isLoading = false;
            this.grid?.setAttribute('aria-busy', 'false');
            this.loadController = undefined;
          }
        }
      };
      syncPaginationState = doc => {
        const marker = doc.querySelector(PAGINATION_SELECTOR);
        this.hasNextPage = marker?.dataset.hasNextPage === 'true';
        this.nextCursor = marker?.dataset.nextCursor || null;
      };
      announce = count => {
        if (!this.liveRegion || !this.grid) return;
        const shown = this.grid.querySelectorAll(CARD_SELECTOR$1).length;
        this.liveRegion.textContent = `${count} articles added. Showing ${shown} articles.`;
      };
      assignMobileOrder = () => {
        if (!this.grid) return;
        const cards = Array.from(this.grid.querySelectorAll(CARD_SELECTOR$1));
        const visible = cards.filter(card => !card.classList.contains('is-hidden'));
        const isPinned = card => Boolean(card.querySelector('.all-articles__card__pinned'));
        const isHorizontalVideo = card => Boolean(card.querySelector('.all-articles__card__video')) && card.dataset.videoOrientation === 'horizontal';
        const partition = predicate => {
          const matched = visible.filter(predicate);
          return [...matched.filter(isPinned), ...matched.filter(card => !isPinned(card))];
        };
        const horizontalVideos = partition(isHorizontalVideo);
        const verticalMedia = partition(card => !isHorizontalVideo(card));
        const sequence = [];
        while (horizontalVideos.length > 0 || verticalMedia.length > 0) {
          const groupVerticals = [];
          while (groupVerticals.length < 2 && verticalMedia.length > 0) {
            groupVerticals.push(verticalMedia.shift());
          }
          const isLoneImage = groupVerticals.length === 1 && !groupVerticals[0].querySelector('.all-articles__card__video');
          groupVerticals.forEach(card => sequence.push({
            card,
            horizontal: isLoneImage
          }));
          if (horizontalVideos.length > 0) {
            sequence.push({
              card: horizontalVideos.shift(),
              horizontal: true
            });
          } else if (verticalMedia.length > 0) {
            sequence.push({
              card: verticalMedia.shift(),
              horizontal: true
            });
          } else if (groupVerticals.length === 0) {
            break;
          }
        }
        sequence.forEach(({
          card,
          horizontal
        }, index) => {
          card.style.setProperty('--mobile-order', String(index));
          card.classList.toggle('is-horizontal', horizontal);
        });
        for (const card of cards) {
          if (card.classList.contains('is-hidden')) {
            card.classList.remove('is-horizontal');
            card.style.setProperty('--mobile-order', String(cards.length));
          }
        }
      };
      initStreamingVideos = () => {
        window.shopstream?.init?.();
      };
      revealImages = root => {
        root.querySelectorAll('img.image:not(.no-lazy-load)').forEach(image => {
          if (image.complete) {
            image.classList.add('loaded');
          } else {
            image.addEventListener('load', () => image.classList.add('loaded'), {
              once: true,
              signal: this.controller?.signal
            });
          }
        });
      };
      fetchArticles = async (cursor, signal) => {
        const url = new URL(API_PROXY.ALL_ARTICLES, window.location.origin);
        if (cursor) url.searchParams.set('cursor', cursor);
        const response = await fetch(url.toString(), {
          signal
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return await response.text();
      };
      static define = () => {
        if (!customElements.get('component-all-articles')) customElements.define('component-all-articles', ComponentAllArticles);
      };
    }
    var componentAllArticles = () => {
      ComponentAllArticles.define();
    };

    var componentAllArticles$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentAllArticles: ComponentAllArticles,
        default: componentAllArticles
    });

    const {
      SSRComponent
    } = window.PoleneLibs.BaseComponent;
    const {
      getElementByRef: getElementByRef$2
    } = window.PoleneLibs.Refs;
    const {
      isMobile
    } = window.PoleneLibs.Utils;
    const {
      ArticleCardVisibleEvent
    } = window.PoleneLibs.BlogArticleEvents;
    const events = window.PoleneLibs.Events.default;
    const {
      dispatchEvent
    } = window.PoleneLibs.Utils;
    const CARD_SELECTOR = '.all-articles__card';
    const NAV_LINK_SELECTOR = '.nav-articles__list__item__link';
    const GRID_TAG = 'component-all-articles';
    const MAX_CACHED_ARTICLES = 40;
    const MAX_CONCURRENT_PREFETCH = 2;
    const ARTICLE_ROOT_SELECTORS = ['.store-article', '.plain-article', '.article'];
    const MAIN_SELECTOR = '#main-content';
    const ARTICLE_BODY_STOP_SELECTORS = ['#shopify-section-footer', '.section-article-list'];
    const SCRAPE_TIMEOUT_MS = 5000;
    class BlogViewerArticle extends SSRComponent {
      activeBlog = null;
      originFocus = null;
      cache = new Map();
      prefetchQueue = [];
      activePrefetches = 0;
      listTitle = '';
      lastScrollY = 0;
      scrollTicking = false;
      onMount() {
        this.listTitle = document.title;
        this.initializeElements();
        this.setupEventListeners();
        this.restoreFromURL();
        this.navList?.classList.add('is-revealed');
        this.lastScrollY = window.scrollY;
        this.updateNavScrollState();
      }
      onUnmount() {
        this.loadController?.abort();
        this.loadController = undefined;
      }
      initializeElements = () => {
        const {
          blogViewerNav
        } = getElementByRef$2('blog-viewer-nav', this);
        const {
          blogViewerList
        } = getElementByRef$2('blog-viewer-list', this);
        const {
          blogViewerContent
        } = getElementByRef$2('blog-viewer-content', this);
        const {
          blogViewerSlot
        } = getElementByRef$2('blog-viewer-slot', this);
        const {
          allArticlesLive
        } = getElementByRef$2('all-articles-live', this);
        this.nav = blogViewerNav;
        this.list = blogViewerList;
        this.article = blogViewerContent;
        this.contentContainer = blogViewerSlot;
        this.live = allArticlesLive;
        const renderedNav = this.list.querySelector('.nav-articles');
        if (renderedNav) this.nav.append(renderedNav);
        const {
          navArticlesList
        } = getElementByRef$2('nav-articles-list', this);
        this.navList = navArticlesList;
      };
      setupEventListeners = () => {
        const {
          signal
        } = this.controller;
        this.nav.addEventListener('click', this.onListClick, {
          signal
        });
        this.list.addEventListener('click', this.onListClick, {
          signal
        });
        this.addEventListener('article-card-visible', this.onCardVisible, {
          signal
        });
        window.addEventListener('popstate', this.onPopstate, {
          signal
        });
        window.addEventListener('scroll', this.onWindowScroll, {
          signal,
          passive: true
        });
        window.addEventListener('resize', this.onWindowResize, {
          signal,
          passive: true
        });
      };
      onWindowScroll = () => {
        if (this.scrollTicking) return;
        this.scrollTicking = true;
        requestAnimationFrame(() => {
          this.updateNavScrollState();
          this.scrollTicking = false;
        });
      };
      onWindowResize = () => {
        if (isMobile()) this.nav.classList.remove('is-nav-hidden');
        this.updateNavScrollState();
      };
      updateNavScrollState = () => {
        const stickyTop = Number.parseFloat(getComputedStyle(this.nav).top) || 0;
        const stuck = this.nav.getBoundingClientRect().top <= stickyTop + 1;
        this.nav.classList.toggle('is-stuck', stuck);
        if (isMobile()) {
          this.nav.classList.remove('is-nav-hidden');
          this.lastScrollY = window.scrollY;
          return;
        }
        const y = window.scrollY;
        const delta = y - this.lastScrollY;
        if (y <= 10) {
          this.nav.classList.remove('is-nav-hidden');
        } else if (Math.abs(delta) > 2) {
          this.nav.classList.toggle('is-nav-hidden', delta > 0);
        }
        this.lastScrollY = y;
      };
      onListClick = event => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;
        const target = event.target;
        if (target.closest('component-video-toggle')) return;
        const card = target.closest(CARD_SELECTOR);
        if (card) {
          const link = card.querySelector('.all-articles__card__link');
          const href = link?.href ?? this.articleURL(card.dataset.article ?? '');
          event.preventDefault();
          this.originFocus = link ?? card;
          this.openArticle(card.dataset.article ?? '', href, true, link?.getAttribute('aria-label') ?? undefined);
          return;
        }
        const link = target.closest(NAV_LINK_SELECTOR);
        if (!link) return;
        if (link.dataset.navKind === 'blog') {
          event.preventDefault();
          this.originFocus = link;
          if (!this.article.hidden) {
            this.article.hidden = true;
            this.list.hidden = false;
            document.title = this.listTitle;
          }
          this.filterBlog(link.dataset.navRef ?? null, true);
          this.scrollToTop();
          this.emitEditoMenuClicked(link.textContent?.trim() || '', link.dataset.navRef ?? '');
        } else if (link.dataset.navKind === 'article') {
          event.preventDefault();
          this.originFocus = link;
          this.openArticle(link.dataset.navRef ?? '', link.href, true, link.textContent?.trim() || undefined);
        } else if (this.isSamePage(link)) {
          event.preventDefault();
          this.originFocus = link;
          this.resetToAll(true);
          this.scrollToTop();
          this.emitEditoMenuClicked(link.textContent?.trim() || '', 'all');
        }
      };
      isSamePage = link => {
        try {
          return new URL(link.href).pathname === window.location.pathname;
        } catch {
          return false;
        }
      };
      resetToAll = push => {
        this.article.hidden = true;
        this.list.hidden = false;
        document.title = this.listTitle;
        this.filterBlog(null, push);
      };
      openArticle = async (ref, url, push, title) => {
        if (!url) return;
        const normalizedRef = this.normalizeArticleRef(ref);
        this.article.setAttribute('aria-busy', 'true');
        this.loadController?.abort();
        const controller = new AbortController();
        this.loadController = controller;
        try {
          const {
            html,
            title: fetchedTitle
          } = await this.getArticle(normalizedRef, url, controller.signal);
          if (this.loadController !== controller) return;
          if (!html) {
            window.location.assign(url);
            return;
          }
          const resolvedTitle = title ?? fetchedTitle ?? this.articleTitle(normalizedRef);
          this.syncHTML(html);
          this.revealMedia(this.article);
          this.list.hidden = true;
          this.article.hidden = false;
          document.documentElement.setAttribute('data-view', 'article');
          this.syncNavCurrent(null, normalizedRef);
          this.article.focus({
            preventScroll: true
          });
          this.scrollToTop();
          if (resolvedTitle) document.title = resolvedTitle;
          this.announce(this.fill(this.dataset.i18nOpened, {
            title: resolvedTitle ?? ''
          }));
          this.emitArticleClicked(resolvedTitle ?? '');
          if (push) this.pushState({
            view: 'article',
            ref: normalizedRef,
            blog: this.activeBlog
          });
        } catch (error) {
          if (this.loadController !== controller) return;
          if (error instanceof DOMException && error.name === 'AbortError') return;
          window.location.assign(url);
        } finally {
          if (this.loadController === controller) {
            this.article.setAttribute('aria-busy', 'false');
            this.loadController = undefined;
          }
        }
      };
      showList = push => {
        this.article.hidden = true;
        this.list.hidden = false;
        document.documentElement.setAttribute('data-view', 'blog');
        document.title = this.listTitle;
        this.originFocus?.focus({
          preventScroll: true
        });
        if (push) this.pushState({
          view: 'list',
          blog: this.activeBlog
        });
      };
      filterBlog = (handle, push) => {
        this.activeBlog = handle;
        const count = this.grid?.filterByBlog?.(handle) ?? 0;
        this.syncNavCurrent(handle);
        if (handle) this.announce(this.fill(this.dataset.i18nFiltered, {
          category: this.navLabel(handle),
          count
        }));else this.announce(this.dataset.i18nReset ?? '');
        if (push) this.pushState({
          view: 'list',
          blog: handle
        });
      };
      pushState = state => {
        const url = new URL(window.location.href);
        url.searchParams.delete('article');
        url.searchParams.delete('blog');
        if (state.view === 'article') url.searchParams.set('article', state.ref);
        if (state.blog) url.searchParams.set('blog', state.blog);
        history.pushState(state, '', url);
      };
      onPopstate = event => this.applyState(event.state ?? this.readURLState());
      restoreFromURL = () => {
        const state = this.readURLState();
        if (state.blog) this.filterBlog(state.blog, false);else this.syncNavCurrent(null);
        if (state.view === 'article') this.openArticle(state.ref, this.articleURL(state.ref), false);
      };
      applyState = state => {
        this.filterBlog(state.blog, false);
        if (state.view === 'article') this.openArticle(state.ref, this.articleURL(state.ref), false);else this.showList(false);
      };
      readURLState = () => {
        const params = new URLSearchParams(window.location.search);
        const ref = params.get('article');
        const blog = params.get('blog');
        if (ref) return {
          view: 'article',
          ref,
          blog
        };
        return {
          view: 'list',
          blog
        };
      };
      onCardVisible = event => {
        if (!(event instanceof ArticleCardVisibleEvent)) return;
        const {
          ref,
          url
        } = event.detail;
        if (!ref || !url || this.cache.has(ref) || this.isDataSaverEnabled()) return;
        this.prefetchQueue.push({
          ref,
          url
        });
        if (this.prefetchQueue.length > MAX_CACHED_ARTICLES) this.prefetchQueue.shift();
        this.drainPrefetchQueue();
      };
      isDataSaverEnabled = () => {
        const connection = navigator.connection;
        return connection?.saveData === true;
      };
      drainPrefetchQueue = () => {
        while (this.activePrefetches < MAX_CONCURRENT_PREFETCH && this.prefetchQueue.length > 0) {
          const next = this.prefetchQueue.pop();
          if (this.cache.has(next.ref)) continue;
          this.runPrefetch(next.ref, next.url);
        }
      };
      runPrefetch = (ref, url) => {
        this.activePrefetches += 1;
        this.evictOldestIfFull();
        const promise = this.scrapeArticle(url, this.controller.signal).catch(error => {
          this.cache.delete(ref);
          throw error;
        });
        promise.finally(() => {
          this.activePrefetches -= 1;
          this.drainPrefetchQueue();
        }).catch(() => {});
        this.cache.set(ref, promise);
      };
      evictOldestIfFull = () => {
        if (this.cache.size < MAX_CACHED_ARTICLES) return;
        const oldestKey = this.cache.keys().next().value;
        if (oldestKey !== undefined) this.cache.delete(oldestKey);
      };
      getArticle = async (ref, url, signal) => {
        const cached = this.cache.get(ref);
        if (cached) {
          try {
            return await cached;
          } catch {
            this.cache.delete(ref);
          }
        }
        return await this.scrapeArticle(url, signal);
      };
      scrapeArticle = async (url, signal) => {
        const response = await fetch(url, {
          signal: AbortSignal.any([signal, AbortSignal.timeout(SCRAPE_TIMEOUT_MS)])
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const html = this.articleHTML(doc);
        if (!html) throw new Error('Blog viewer: no article content found in scraped page');
        return {
          html,
          title: doc.title || undefined
        };
      };
      articleHTML = doc => {
        const root = ARTICLE_ROOT_SELECTORS.map(selector => doc.querySelector(selector)).find(el => el !== null);
        if (root) {
          const mainSection = root.closest('[id^="shopify-section-"]');
          return root.outerHTML + this.sectionsAfter(mainSection).map(section => section.outerHTML).join('');
        }
        const firstSection = Array.from(doc.querySelector(MAIN_SELECTOR)?.children ?? []).find(el => el.id.startsWith('shopify-section-'));
        if (!firstSection) return '';
        return [firstSection, ...this.sectionsAfter(firstSection)].map(section => section.outerHTML).join('');
      };
      sectionsAfter = start => {
        const sections = [];
        let cursor = start?.nextElementSibling ?? null;
        while (cursor) {
          const section = cursor;
          if (ARTICLE_BODY_STOP_SELECTORS.some(selector => section.matches(selector))) break;
          if (section.id.startsWith('shopify-section-')) sections.push(section);
          cursor = section.nextElementSibling;
        }
        return sections;
      };
      articleTitle = ref => {
        const normalized = this.normalizeArticleRef(ref);
        const cardLink = this.list.querySelector(`[data-article="${CSS.escape(normalized)}"] .all-articles__card__link`);
        const label = cardLink?.getAttribute('aria-label')?.trim();
        if (label) return label;
        const navLinks = this.nav.querySelectorAll(`${NAV_LINK_SELECTOR}[data-nav-kind="article"]`);
        for (let i = 0; i < navLinks.length; i++) {
          const link = navLinks[i];
          if (this.normalizeArticleRef(link.dataset.navRef ?? '') === normalized) {
            return link.textContent?.trim() || undefined;
          }
        }
        return undefined;
      };
      revealMedia = root => {
        root.querySelectorAll('img.image:not(.no-lazy-load)').forEach(image => {
          if (image.complete) image.classList.add('loaded');else image.addEventListener('load', () => image.classList.add('loaded'), {
            once: true,
            signal: this.controller?.signal
          });
        });
        root.querySelectorAll('[data-ref="reveal-element"]').forEach(el => el.classList.add('is-revealed'));
        window.shopstream?.init?.();
      };
      syncNavCurrent = (handle, articleRef) => {
        const normalizedArticle = articleRef ? this.normalizeArticleRef(articleRef) : '';
        let articleMatched = false;
        this.nav.querySelectorAll(`${NAV_LINK_SELECTOR}[data-nav-kind="article"]`).forEach(link => {
          const ref = this.normalizeArticleRef(link.dataset.navRef ?? '');
          const match = Boolean(normalizedArticle && ref === normalizedArticle);
          if (match) {
            link.setAttribute('aria-current', 'true');
            articleMatched = true;
          } else {
            link.removeAttribute('aria-current');
          }
        });
        this.nav.querySelectorAll(`${NAV_LINK_SELECTOR}[data-nav-kind="blog"]`).forEach(link => {
          if (!articleMatched && handle && link.dataset.navRef === handle) link.setAttribute('aria-current', 'true');else link.removeAttribute('aria-current');
        });
        this.nav.querySelectorAll(`${NAV_LINK_SELECTOR}:not([data-nav-kind])`).forEach(link => {
          if (!articleMatched && !normalizedArticle && !handle && this.isSamePage(link)) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
        this.centerActiveNavLink();
      };
      centerActiveNavLink = () => {
        if (!this.navList || !isMobile()) return;
        const activeLink = this.navList.querySelector(`${NAV_LINK_SELECTOR}[aria-current='true']`);
        const activeItem = activeLink?.parentElement;
        if (!activeItem) return;
        const navWidth = this.navList.offsetWidth;
        const scrollPosition = activeItem.offsetLeft - navWidth / 2 + activeItem.offsetWidth / 2;
        this.navList.scrollTo({
          left: scrollPosition,
          behavior: 'instant'
        });
      };
      normalizeArticleRef = ref => ref.replace(/^\/+/, '');
      scrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: 'instant'
        });
        this.lastScrollY = 0;
        this.updateNavScrollState();
      };
      navLabel = handle => {
        const link = this.nav.querySelector(`[data-nav-kind="blog"][data-nav-ref="${handle}"]`);
        return link?.textContent?.trim() ?? handle;
      };
      emitArticleClicked = articleTitle => {
        dispatchEvent(window, events.ARTICLE_CLICKED, {
          article_title: articleTitle
        });
      };
      emitEditoMenuClicked = (tabLabel, tabHandle) => {
        dispatchEvent(window, events.EDITO_MENU_CLICKED, {
          tab_label: tabLabel,
          tab_handle: tabHandle
        });
      };
      articleURL = ref => `${ROOT_PATH}/blogs/${this.normalizeArticleRef(ref)}`.replace(/\/+/g, '/');
      fill = (template, vars) => Object.entries(vars).reduce((text, [key, value]) => text.replace(`%${key}%`, String(value)), template ?? '');
      announce = message => {
        if (this.live) this.live.textContent = message;
      };
      get grid() {
        return this.querySelector(GRID_TAG);
      }
      static define = () => {
        if (!customElements.get('blog-viewer-article')) customElements.define('blog-viewer-article', BlogViewerArticle);
      };
    }
    var blogViewerArticle = () => {
      BlogViewerArticle.define();
    };

    var blogViewerArticle$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        BlogViewerArticle: BlogViewerArticle,
        default: blogViewerArticle
    });

    const {
      getElementByRef: getElementByRef$1,
      getElementsByRef: getElementsByRef$2
    } = window.PoleneLibs.Refs;
    class OrderTracker extends HTMLElement {
      trackerTriggers = [];
      list = null;
      details = new Map();
      backButtons = [];
      showAllButtons = [];
      lastFocusedTrigger = null;
      language = undefined;
      connectedCallback() {
        this.controller = new AbortController();
        this.fetchAndRender();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = undefined;
      }
      updatedCallback() {
        this.refresh();
      }
      refresh() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.fetchAndRender();
      }
      init() {
        const {
          orderTrackerList
        } = getElementByRef$1(['order-tracker-list'], this);
        const {
          orderTrackerDetail,
          orderTrackerLink,
          orderTrackerBack,
          orderTrackerShowAll
        } = getElementsByRef$2(['order-tracker-detail', 'order-tracker-link', 'order-tracker-back', 'order-tracker-show-all'], this);
        this.list = orderTrackerList ?? null;
        this.trackerTriggers = orderTrackerLink ? [orderTrackerLink].flat() : [];
        this.backButtons = orderTrackerBack ? [orderTrackerBack].flat() : [];
        this.showAllButtons = orderTrackerShowAll ? [orderTrackerShowAll].flat() : [];
        this.details = new Map();
        if (orderTrackerDetail) {
          for (const el of [orderTrackerDetail].flat()) {
            const id = el.getAttribute('data-tracker-id');
            if (id) this.details.set(id, el);
          }
        }
      }
      setupEventListeners() {
        this.trackerTriggers.forEach(trigger => {
          trigger.addEventListener('click', this.handleTrackerTriggerClick, {
            signal: this.controller?.signal
          });
        });
        this.backButtons.forEach(btn => {
          btn.addEventListener('click', this.handleBackClick, {
            signal: this.controller?.signal
          });
        });
        this.showAllButtons.forEach(btn => {
          btn.addEventListener('click', this.handleShowAll, {
            signal: this.controller?.signal
          });
        });
      }
      handleTrackerTriggerClick = e => {
        e.preventDefault();
        const trigger = e.currentTarget;
        const id = trigger.getAttribute('data-tracker-id');
        this.lastFocusedTrigger = trigger;
        if (this.list) this.list.classList.add('hidden');
        if (id) {
          const detail = this.details.get(id);
          detail?.classList.add('active');
          const focusable = detail?.querySelector(FOCUSABLE_SELECTORS);
          focusable?.focus();
        }
      };
      handleBackClick = e => {
        e.preventDefault();
        this.details.forEach(d => d.classList.remove('active'));
        if (this.list) this.list.classList.remove('hidden');
        this.lastFocusedTrigger?.focus();
        this.lastFocusedTrigger = null;
      };
      handleShowAll = e => {
        const btn = e.currentTarget;
        const container = btn.closest('.order-tracker-widget-delivery-status');
        if (!container) return;
        const extraEvents = container.querySelectorAll('[data-is-extra="true"]');
        if (extraEvents.length === 0) return;
        const willShow = !extraEvents[0].classList.contains('visible');
        extraEvents.forEach(ev => {
          ev.classList.toggle('visible', willShow);
        });
        btn.textContent = willShow ? btn.dataset.textLess || '' : btn.dataset.textMore || '';
        btn.setAttribute('aria-expanded', String(willShow));
      };
      fetchAndRender = async () => {
        const orderNumber = window.location.pathname.split('/').filter(Boolean).at(-1);
        if (!orderNumber) return;
        const {
          signal
        } = this.controller;
        try {
          const url = new URL(API_PROXY.ORDER_TRACKER, window.location.origin);
          url.searchParams.set('order_number', orderNumber);
          if (!!this.dataset.lang) url.searchParams.set('lang', this.dataset.lang);
          const response = await fetch(url.toString(), {
            signal
          });
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
          }
          this.innerHTML = await response.text();
          this.init();
          this.setupEventListeners();
        } catch (error) {
          if (error instanceof DOMException && error.name === 'AbortError') return;
        }
      };
      static define = () => {
        if (!customElements.get('order-tracker')) {
          customElements.define('order-tracker', OrderTracker);
        }
      };
    }
    var orderTracker = () => {
      OrderTracker.define();
    };

    var orderTracker$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        OrderTracker: OrderTracker,
        default: orderTracker
    });

    const {
      getElementsByRef: getElementsByRef$1
    } = window.PoleneLibs.Refs;
    var fragmentStoreSelector = () => {
      const {
        storeSelector
      } = getElementsByRef$1(['store-selector']);
      if (window.P1?.themeSettings?.devSettings?.featureEnableCountrySelector || !storeSelector) return;
      const elements = Array.isArray(storeSelector) ? [...storeSelector] : [storeSelector];
      const teardowns = elements.map(element => {
        const links = Array.from(element.querySelectorAll('a'));
        const handleRoute = e => {
          e.preventDefault();
          const link = e.target;
          const url = new URL(link.href);
          location.href = url.origin + location.pathname;
        };
        if (element.dataset.type === 'list') {
          links.forEach(link => {
            link.classList.toggle('is-active', link.href.includes(location.hostname));
          });
        }
        if (element.dataset.type === 'dropdown') {
          links.forEach(link => {
            link.addEventListener('click', handleRoute);
          });
        }
        return () => {
          if (element.dataset.type === 'dropdown') {
            links.forEach(link => {
              link.removeEventListener('click', handleRoute);
            });
          }
        };
      });
      return () => {
        teardowns.forEach(teardown => teardown());
      };
    };

    var fragmentStoreSelector$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentStoreSelector
    });

    var mapstyle = {
      styles: [{
        elementType: 'geometry',
        stylers: [{
          color: '#EDEAE7'
        }]
      }, {
        elementType: 'labels.icon',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#767676'
        }]
      }, {
        elementType: 'labels.text.stroke',
        stylers: [{
          color: '#EDEAE7'
        }]
      }, {
        featureType: 'administrative',
        elementType: 'geometry',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#bdbdbd'
        }]
      }, {
        featureType: 'poi',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{
          color: '#767676'
        }]
      }, {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#767676'
        }]
      }, {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{
          color: '#e5e5e5'
        }]
      }, {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#9e9e9e'
        }]
      }, {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{
          color: '#ffffff'
        }]
      }, {
        featureType: 'road',
        elementType: 'labels.icon',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'road.arterial',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#767676'
        }]
      }, {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{
          color: '#ffffff'
        }]
      }, {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#767676'
        }]
      }, {
        featureType: 'road.local',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#9e9e9e'
        }]
      }, {
        featureType: 'transit',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'transit.line',
        elementType: 'geometry',
        stylers: [{
          color: '#e5e5e5'
        }]
      }, {
        featureType: 'transit.station',
        elementType: 'geometry',
        stylers: [{
          color: '#767676'
        }]
      }, {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{
          color: '#DCD5CE'
        }]
      }, {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#000000'
        }]
      }]
    };

    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise, SuppressedError, Symbol, Iterator */


    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
        var e = new Error(message);
        return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
    };

    function getDefaultExportFromCjs (x) {
    	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }

    var fastDeepEqual;
    var hasRequiredFastDeepEqual;

    function requireFastDeepEqual () {
    	if (hasRequiredFastDeepEqual) return fastDeepEqual;
    	hasRequiredFastDeepEqual = 1;

    	// do not edit .js files directly - edit src/index.jst



    	fastDeepEqual = function equal(a, b) {
    	  if (a === b) return true;

    	  if (a && b && typeof a == 'object' && typeof b == 'object') {
    	    if (a.constructor !== b.constructor) return false;

    	    var length, i, keys;
    	    if (Array.isArray(a)) {
    	      length = a.length;
    	      if (length != b.length) return false;
    	      for (i = length; i-- !== 0;)
    	        if (!equal(a[i], b[i])) return false;
    	      return true;
    	    }



    	    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    	    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    	    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    	    keys = Object.keys(a);
    	    length = keys.length;
    	    if (length !== Object.keys(b).length) return false;

    	    for (i = length; i-- !== 0;)
    	      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    	    for (i = length; i-- !== 0;) {
    	      var key = keys[i];

    	      if (!equal(a[key], b[key])) return false;
    	    }

    	    return true;
    	  }

    	  // true if both NaN, false otherwise
    	  return a!==a && b!==b;
    	};
    	return fastDeepEqual;
    }

    var fastDeepEqualExports = requireFastDeepEqual();
    var isEqual = /*@__PURE__*/getDefaultExportFromCjs(fastDeepEqualExports);

    /**
     * Copyright 2019 Google LLC. All Rights Reserved.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at.
     *
     *      Http://www.apache.org/licenses/LICENSE-2.0.
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    const DEFAULT_ID = "__googleMapsScriptId";
    /**
     * The status of the [[Loader]].
     */
    var LoaderStatus;
    (function (LoaderStatus) {
        LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
        LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
        LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
        LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
    })(LoaderStatus || (LoaderStatus = {}));
    /**
     * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
     * dynamically using
     * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
     * It works by dynamically creating and appending a script node to the the
     * document head and wrapping the callback function so as to return a promise.
     *
     * ```
     * const loader = new Loader({
     *   apiKey: "",
     *   version: "weekly",
     *   libraries: ["places"]
     * });
     *
     * loader.load().then((google) => {
     *   const map = new google.maps.Map(...)
     * })
     * ```
     */
    class Loader {
        /**
         * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
         * using this library, instead the defaults are set by the Google Maps
         * JavaScript API server.
         *
         * ```
         * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
         * ```
         */
        constructor({ apiKey, authReferrerPolicy, channel, client, id = DEFAULT_ID, language, libraries = [], mapIds, nonce, region, retries = 3, url = "https://maps.googleapis.com/maps/api/js", version, }) {
            this.callbacks = [];
            this.done = false;
            this.loading = false;
            this.errors = [];
            this.apiKey = apiKey;
            this.authReferrerPolicy = authReferrerPolicy;
            this.channel = channel;
            this.client = client;
            this.id = id || DEFAULT_ID; // Do not allow empty string
            this.language = language;
            this.libraries = libraries;
            this.mapIds = mapIds;
            this.nonce = nonce;
            this.region = region;
            this.retries = retries;
            this.url = url;
            this.version = version;
            if (Loader.instance) {
                if (!isEqual(this.options, Loader.instance.options)) {
                    throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(Loader.instance.options)}`);
                }
                return Loader.instance;
            }
            Loader.instance = this;
        }
        get options() {
            return {
                version: this.version,
                apiKey: this.apiKey,
                channel: this.channel,
                client: this.client,
                id: this.id,
                libraries: this.libraries,
                language: this.language,
                region: this.region,
                mapIds: this.mapIds,
                nonce: this.nonce,
                url: this.url,
                authReferrerPolicy: this.authReferrerPolicy,
            };
        }
        get status() {
            if (this.errors.length) {
                return LoaderStatus.FAILURE;
            }
            if (this.done) {
                return LoaderStatus.SUCCESS;
            }
            if (this.loading) {
                return LoaderStatus.LOADING;
            }
            return LoaderStatus.INITIALIZED;
        }
        get failed() {
            return this.done && !this.loading && this.errors.length >= this.retries + 1;
        }
        /**
         * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
         *
         * @ignore
         * @deprecated
         */
        createUrl() {
            let url = this.url;
            url += `?callback=__googleMapsCallback&loading=async`;
            if (this.apiKey) {
                url += `&key=${this.apiKey}`;
            }
            if (this.channel) {
                url += `&channel=${this.channel}`;
            }
            if (this.client) {
                url += `&client=${this.client}`;
            }
            if (this.libraries.length > 0) {
                url += `&libraries=${this.libraries.join(",")}`;
            }
            if (this.language) {
                url += `&language=${this.language}`;
            }
            if (this.region) {
                url += `&region=${this.region}`;
            }
            if (this.version) {
                url += `&v=${this.version}`;
            }
            if (this.mapIds) {
                url += `&map_ids=${this.mapIds.join(",")}`;
            }
            if (this.authReferrerPolicy) {
                url += `&auth_referrer_policy=${this.authReferrerPolicy}`;
            }
            return url;
        }
        deleteScript() {
            const script = document.getElementById(this.id);
            if (script) {
                script.remove();
            }
        }
        /**
         * Load the Google Maps JavaScript API script and return a Promise.
         * @deprecated, use importLibrary() instead.
         */
        load() {
            return this.loadPromise();
        }
        /**
         * Load the Google Maps JavaScript API script and return a Promise.
         *
         * @ignore
         * @deprecated, use importLibrary() instead.
         */
        loadPromise() {
            return new Promise((resolve, reject) => {
                this.loadCallback((err) => {
                    if (!err) {
                        resolve(window.google);
                    }
                    else {
                        reject(err.error);
                    }
                });
            });
        }
        importLibrary(name) {
            this.execute();
            return google.maps.importLibrary(name);
        }
        /**
         * Load the Google Maps JavaScript API script with a callback.
         * @deprecated, use importLibrary() instead.
         */
        loadCallback(fn) {
            this.callbacks.push(fn);
            this.execute();
        }
        /**
         * Set the script on document.
         */
        setScript() {
            var _a, _b;
            if (document.getElementById(this.id)) {
                // TODO wrap onerror callback for cases where the script was loaded elsewhere
                this.callback();
                return;
            }
            const params = {
                key: this.apiKey,
                channel: this.channel,
                client: this.client,
                libraries: this.libraries.length && this.libraries,
                v: this.version,
                mapIds: this.mapIds,
                language: this.language,
                region: this.region,
                authReferrerPolicy: this.authReferrerPolicy,
            };
            // keep the URL minimal:
            Object.keys(params).forEach(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (key) => !params[key] && delete params[key]);
            if (!((_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.importLibrary)) {
                // tweaked copy of https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
                // which also sets the base url, the id, and the nonce
                /* eslint-disable */
                ((g) => {
                    // @ts-ignore
                    let h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
                    // @ts-ignore
                    b = b[c] || (b[c] = {});
                    // @ts-ignore
                    const d = b.maps || (b.maps = {}), r = new Set(), e = new URLSearchParams(), u = () => 
                    // @ts-ignore
                    h || (h = new Promise((f, n) => __awaiter(this, void 0, void 0, function* () {
                        var _a;
                        yield (a = m.createElement("script"));
                        a.id = this.id;
                        e.set("libraries", [...r] + "");
                        // @ts-ignore
                        for (k in g)
                            e.set(k.replace(/[A-Z]/g, (t) => "_" + t[0].toLowerCase()), g[k]);
                        e.set("callback", c + ".maps." + q);
                        a.src = this.url + `?` + e;
                        d[q] = f;
                        a.onerror = () => (h = n(Error(p + " could not load.")));
                        // @ts-ignore
                        a.nonce = this.nonce || ((_a = m.querySelector("script[nonce]")) === null || _a === void 0 ? void 0 : _a.nonce) || "";
                        m.head.append(a);
                    })));
                    // @ts-ignore
                    d[l] ? console.warn(p + " only loads once. Ignoring:", g) : (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)));
                })(params);
                /* eslint-enable */
            }
            // While most libraries populate the global namespace when loaded via bootstrap params,
            // this is not the case for "marker" when used with the inline bootstrap loader
            // (and maybe others in the future). So ensure there is an importLibrary for each:
            const libraryPromises = this.libraries.map((library) => this.importLibrary(library));
            // ensure at least one library, to kick off loading...
            if (!libraryPromises.length) {
                libraryPromises.push(this.importLibrary("core"));
            }
            Promise.all(libraryPromises).then(() => this.callback(), (error) => {
                const event = new ErrorEvent("error", { error }); // for backwards compat
                this.loadErrorCallback(event);
            });
        }
        /**
         * Reset the loader state.
         */
        reset() {
            this.deleteScript();
            this.done = false;
            this.loading = false;
            this.errors = [];
            this.onerrorEvent = null;
        }
        resetIfRetryingFailed() {
            if (this.failed) {
                this.reset();
            }
        }
        loadErrorCallback(e) {
            this.errors.push(e);
            if (this.errors.length <= this.retries) {
                const delay = this.errors.length * Math.pow(2, this.errors.length);
                console.error(`Failed to load Google Maps script, retrying in ${delay} ms.`);
                setTimeout(() => {
                    this.deleteScript();
                    this.setScript();
                }, delay);
            }
            else {
                this.onerrorEvent = e;
                this.callback();
            }
        }
        callback() {
            this.done = true;
            this.loading = false;
            this.callbacks.forEach((cb) => {
                cb(this.onerrorEvent);
            });
            this.callbacks = [];
        }
        execute() {
            this.resetIfRetryingFailed();
            if (this.loading) {
                // do nothing but wait
                return;
            }
            if (this.done) {
                this.callback();
            }
            else {
                // short circuit and warn if google.maps is already loaded
                if (window.google && window.google.maps && window.google.maps.version) {
                    console.warn("Google Maps already loaded outside @googlemaps/js-api-loader. " +
                        "This may result in undesirable behavior as options and script parameters may not match.");
                    this.callback();
                    return;
                }
                this.loading = true;
                this.setScript();
            }
        }
    }

    const {
      getElementByRef,
      getRefs
    } = window.PoleneLibs.Refs;
    const loader = new Loader({
      apiKey: window?.P1?.themeSettings?.googleMap?.apiKey || '',
      version: 'weekly',
      libraries: ['places']
    });
    var fragmentSplitscreenMap = () => {
      const ref = getElementByRef(['splitscreen-map']);
      if (!ref.splitscreenMap?.dataset?.lat || !ref.splitscreenMap?.dataset?.lng) return;
      const {
        lat,
        lng
      } = ref.splitscreenMap.dataset;
      const position = {
        lat: parseFloat(lat),
        lng: parseFloat(lng)
      };
      const {
        mapContainer
      } = getRefs(ref.splitscreenMap);
      const initMap = () => {
        const map = new google.maps.Map(mapContainer, {
          center: position,
          zoom: 16,
          styles: mapstyle.styles,
          disableDefaultUI: true
        });
        const icon = {
          path: 'M25.2,5.1c-5.6-5.6-14.7-5.6-20.3,0s-5.6,14.7,0,20.3L15,35.5l10.1-10.1C30.8,19.8,30.8,10.7,25.2,5.1z M15.1,21.2c-3.4,0-6.1-2.7-6.1-6.1S11.7,9,15.1,9s6.1,2.7,6.1,6.1C21.1,18.5,18.4,21.2,15.1,21.2z',
          fillColor: '#000000',
          fillOpacity: 1,
          anchor: new google.maps.Point(13, 30)
        };
        new google.maps.Marker({
          position: position,
          map,
          icon: icon
        });
      };
      if (lng && lat && mapContainer) {
        loader.load().then(() => {
          initMap();
        }).catch(e => {});
      }
    };

    var fragmentSplitscreenMap$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentSplitscreenMap
    });

    const {
      intersection
    } = window.PoleneLibs.Observer;
    const {
      getElementsByRef
    } = window.PoleneLibs.Refs;
    const classes = {
      hidden: 'is-hidden'
    };
    var sectionArticleList = () => {
      const {
        articleList,
        title
      } = getElementsByRef(['article-list', 'title']);
      if (!articleList) return;
      const handleIntersection = ([entry]) => {
        if (!title || Array.isArray(title)) return;
        if (entry.isIntersecting) {
          title.classList.add(classes.hidden);
        } else {
          if (entry.boundingClientRect.top > 0) {
            title.classList.remove(classes.hidden);
          }
        }
      };
      const observer = intersection(articleList, handleIntersection, {
        threshold: [0.5]
      });
      return () => {
        if (!Array.isArray(articleList)) observer.unobserve(articleList);else articleList.forEach(article => observer.unobserve(article));
      };
    };

    var sectionArticleList$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: sectionArticleList
    });

})();
